import { isAutoGeneratedName, shouldSkipQuestionnaireModal } from "common";
import { ArrivalError, Guest, PurchaseItem } from "types";
import { hasEmptyRequiredFields } from "../../../models/Guest";
import { CreatePurchaseItemState } from "../../../stores/createPurchaseStore";
import { usePurchaseResponseStore } from "../store/usePurchaseResponseStore";
import { isMembershipItem } from "@/models/PurchaseItem";

export const hasSomeEmptyNameField = (item: CreatePurchaseItemState | PurchaseItem) => {
    const isMembership = isMembershipItem(item);

    const isGuestNameInvalid = (guest: Guest) => {
        if (isMembership) {
            return !guest.name || isAutoGeneratedName(guest.name);
        }

        return !guest.name;
    };

    return !item.guests || item.guests.length === 0 || item.guests.some((item) => isGuestNameInvalid(item));
};

export const hasSomeEmptyRequiredFields = (item: CreatePurchaseItemState, isOrganizerOnly?: boolean) => {
    const form = usePurchaseResponseStore.getState().purchase.items?.find(({ id }) => id === item.id)?.form;
    if (!item) {
        return true;
    }

    if (hasSomeEmptyNameField(item)) {
        return true;
    }

    if (!form || !item.guests?.length) {
        return false;
    }

    const itemAdditionalInformationQuestions = form?.fields.filter(
        (field) => shouldSkipQuestionnaireModal(field) && field.required,
    );
    const hasEmptyItemLevelQuestions =
        itemAdditionalInformationQuestions.length >
        (item.formResponse?.fields?.filter((field) => field.value) ?? []).length;

    if (hasEmptyItemLevelQuestions) {
        return true;
    }

    return form.organizerOnly
        ? hasEmptyRequiredFields(item.guests[0], form, item.formResponse, isOrganizerOnly)
        : item.guests?.some((guest) => hasEmptyRequiredFields(guest, form, undefined, isOrganizerOnly));
};

export const getArrivalErrorMessages = (errors: ArrivalError[]) => {
    const messages = [];

    const arrivalErrors = errors.filter((error) => "field" in error && error.field === "arrivalDateTime") ?? [];

    for (const error of arrivalErrors) {
        messages.push(error.message);
    }

    return messages;
};
